// Floating WhatsApp button.
//
// Fixed to the bottom-left corner, always visible during scroll. Links to the
// same WhatsApp number used in the footer contact section
// (`landing/components/contact.ts`): https://wa.me/573124453260
//
// The classic WhatsApp glyph is rendered as inline SVG so it needs no external
// asset and inherits crisp rendering at any size.

const WHATSAPP_URL = 'https://wa.me/573124453260'

const WHATSAPP_ICON = `
  <svg viewBox="0 0 32 32" width="32" height="32" fill="currentColor" aria-hidden="true" focusable="false">
    <path d="M16.004 0h-.008C7.174 0 0 7.176 0 16c0 3.5 1.128 6.744 3.046 9.38L1.05 31.3l6.128-1.96A15.9 15.9 0 0 0 16.004 32C24.826 32 32 24.822 32 16S24.826 0 16.004 0z" fill="#25D366"/>
    <path d="M25.324 22.598c-.386 1.09-1.918 1.994-3.14 2.258-.836.178-1.928.32-5.604-1.204-4.702-1.948-7.73-6.726-7.966-7.036-.226-.31-1.9-2.53-1.9-4.826s1.166-3.422 1.636-3.902c.386-.394.848-.574 1.412-.574.182 0 .346.01.494.016.472.02.71.048 1.02.79.386.928 1.324 3.224 1.436 3.458.114.234.228.55.07.86-.148.32-.278.462-.512.732-.234.27-.456.478-.69.768-.214.252-.456.522-.186.986.27.456 1.2 1.978 2.576 3.204 1.776 1.582 3.216 2.086 3.73 2.3.384.16.842.122 1.122-.18.356-.386.796-1.026 1.244-1.656.318-.452.72-.508 1.142-.348.43.15 2.716 1.28 3.186 1.514.47.234.78.348.894.542.114.198.114 1.13-.272 2.218z" fill="#FFF"/>
  </svg>
`

/**
 * Injects the floating WhatsApp button into the document body. Idempotent: if
 * the button already exists it does nothing.
 */
export function initWhatsAppFloat(): void {
  if (document.getElementById('whatsapp-float')) return

  const link = document.createElement('a')
  link.id = 'whatsapp-float'
  link.className = 'whatsapp-float'
  link.href = WHATSAPP_URL
  link.target = '_blank'
  link.rel = 'noopener noreferrer'
  link.setAttribute('aria-label', 'WhatsApp')
  link.innerHTML = WHATSAPP_ICON

  document.body.appendChild(link)
}
